import { STPlaceholderType } from '@tencent/slide-sdk-pb-model';

export const HEADER_OR_FOOTER_PLACEHOLDER_TYPES = [
    STPlaceholderType.dt,
    STPlaceholderType.ftr,
    STPlaceholderType.sldNum,
];

export const ORPHAN_INDEX = 4294967295;
